import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { styled } from 'styletron-react';

interface TableEntryProps {
  leftValues?: React.ReactNode[];
  rightValues?: React.ReactNode[];
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  additionalClassNames?: string;
  additionalTestId?: string;
}

let uniqueElementCounter = 0;

const CenteringCol = styled(Col, {
  lineHeight: '24px'
});

const EntryRow = styled(Row, {
  paddingTop: '14px',
  paddingBottom: '14px',
  paddingLeft: '16px',
  paddingRight: '16px',
  '@media (max-width: 767px)': {
    paddingTop: '14px',
    paddingBottom: '14px'
  }
});

function generateUniqueId() {
  return 'id_' + uniqueElementCounter++;
}

const generateValueElements = (values: React.ReactNode[], isBold: boolean = false) =>
  values.map((value) => (
    <Col xs={12} key={generateUniqueId()}>
      {React.isValidElement(value) ? (
        <p className={`mx-0 my-auto ${isBold ? 'fw-bold' : ''}`}>{value}</p>
      ) : (
        <p
          className={`mx-0 my-auto ${isBold ? 'fw-bold' : ''}`}
          dangerouslySetInnerHTML={{ __html: value as string }}
        />
      )}
    </Col>
  ));

const TableEntry = ({
  leftValues,
  rightValues,
  startElement,
  endElement,
  rightElement,
  additionalClassNames,
  additionalTestId
}: TableEntryProps) => {
  const leftValueElements = leftValues ? generateValueElements(leftValues) : null;
  const rightValueElements = rightValues ? generateValueElements(rightValues, true) : null;

  return (
    <EntryRow
      className={`justify-content-center ${additionalClassNames || ''}`}
      data-gi={additionalTestId}
    >
      {startElement && (
        <Col xs="auto" className="pe-0" style={{ width: '40px' }}>
          {startElement}
        </Col>
      )}

      <Col xs>
        <Row>
          {leftValues && (
            <CenteringCol xs={12} md className="d-flex">
              <Row>{leftValueElements}</Row>
            </CenteringCol>
          )}
          {rightValues ? (
            <CenteringCol xs={12} md className="d-flex mt-3 mt-md-0">
              <Row data-gi="right-col">{rightValueElements}</Row>
            </CenteringCol>
          ) : (
            rightElement
          )}
        </Row>
      </Col>

      {endElement && (
        <CenteringCol xs="auto" className="d-flex">
          {endElement}
        </CenteringCol>
      )}
    </EntryRow>
  );
};

export default TableEntry;
